
import React, { useState } from "react"
import PropTypes from "prop-types"

import PhoneIcon from '../images/phone.svg';
import EmailIcon from '../images/email.svg';
import NameIcon from '../images/name.svg';
import EducationIcon from '../images/education.svg';

import Client from "../api/Client"
import Player from "../components/Player"
import ApplicantActions from "../components/ApplicantActions"

const propTypes = {
    jobApplication: PropTypes.object.isRequired,
    onModalOpen: PropTypes.func,
    allowToggle: PropTypes.bool.isRequired,
    onPlay: PropTypes.func.isRequired,
    onHide: PropTypes.func,
};

const wrapEmail = (email) => {
    if (!email) return email;
    const at = String(email).indexOf('@');
    if (at === -1) return email;
    return (
        <>
            {email.slice(0, at + 1)}
            <wbr />
            {email.slice(at + 1)}
        </>
    );
};

const InfoRow = ({ icon, children, title }) => (
    <p className="job-application-row__field mb-2">
        <span className="job-application-row__icon" aria-hidden="true">
            <img width="24" height="24" src={icon} alt="" />
        </span>
        <span className="job-application-row__value" title={title}>
            {children}
        </span>
    </p>
);

const JobApplication = (props) => {
    const [viewed, setViewed] = useState(props.jobApplication.attributes.viewed);

    const markViewedJobApplication = () => {
      if (viewed) return;

      Client.markViewedJobApplication(props.jobApplication.id).then((x) => {
        setViewed(true);
      })
    }

    const triggerOnPlay = (player) => {
      markViewedJobApplication()
      props.onPlay(player)
    }

    return(
        <tr className="job-application-row" style={props.style}>
            <td className="job-application-row__video position-relative resize p-0">
                <Player
                    jobApplication={props.jobApplication}
                    onPlay={triggerOnPlay}
                />
                { props.jobApplication.attributes.status === 'created_by_company' && (
                  <span className="company-application-badge">
                    created by company
                  </span>
                )}
            </td>
            <td className="job-application-row__info applicant-info">
                <span className="job-application-row__section-label">Applicant</span>
                <InfoRow icon={NameIcon} title={props.jobApplication.attributes.applicant.name}>
                    {props.jobApplication.attributes.applicant.name}
                </InfoRow>

                <InfoRow icon={EmailIcon} title={props.jobApplication.attributes.applicant.email}>
                    {wrapEmail(props.jobApplication.attributes.applicant.email)}
                </InfoRow>

                <InfoRow icon={PhoneIcon} title={props.jobApplication.attributes.formatted_phone_number}>
                    {props.jobApplication.attributes.formatted_phone_number}
                </InfoRow>

                <InfoRow icon={EducationIcon} title={props.jobApplication.attributes.applicant.education}>
                    {props.jobApplication.attributes.applicant.education}
                </InfoRow>
            </td>

            <td className="job-application-row__fact resize">
                <span className="job-application-row__section-label">Fun fact</span>
                <p>
                    {props.jobApplication.attributes.fun_fact}
                </p>
            </td>
            <td className="job-application-row__actions">
              <ApplicantActions
                  jobApplication={props.jobApplication}
                  allowToggle={props.allowToggle}
                  onModalOpen={props.onModalOpen}
                  onHide={props.onHide}
              />
            </td>
        </tr>
    )
};

JobApplication.propTypes = propTypes;

export default JobApplication;
